<!--
<div class="menu1 d-none d-lg-inline-block" id = "portt" >

   <p  class="menup" id="pat" (click) = "menclick('pat')"> {{menu1}}<img class="cursores" id="patf"  src="../../assets/chain/selec.png"/> </p>
   <p class="menup" id="somos" (click) = "menclick('somos')"> {{menu2}} <img class="cursores" id="somosf"  src="../../assets/chain/unselect.png"/> </p>
   <p class="menup" id="serv" (click) = "menclick('serv')"> {{menu3}} <img class="cursores" id="servf"  src="../../assets/chain/unselect.png"/> </p> 
    <p class="menup" id="proy" (click) = "menclick('proy')"> {{menu5}} <img class="cursores" id="proyf"  src="../../assets/chain/unselect.png"/> </p> 
   <p  class="menup" id="con" (click) = "menclick('con')"> <br> <br> <br> {{menu4}} <img id="conf"  class="cursores" src="../../assets/chain/unselect.png"/> </p>
 
 </div>


 <div class="d-lg-none headerMob" >

 </div>


 <img (click)= "menclick('pat')" routerLink="/" class="logohead" src="../../assets/chain/Asset 1.png" id="LogoPos" />
 <img (click)= "menclick('pat')" routerLink="/" class="logohead" src="../../assets/chain/logoHead.png" id="nodosL" />
 
 <div class="redes  d-none d-lg-inline-block">
 	<a href="https://www.instagram.com/patagoniachain/?hl=es" target="_blank"><img  src="../../assets/chain/Instagram.png" /></a>
 	|
 	<a href="https://www.linkedin.com/company/patagonia-chain/about/" target="_blank"> <img src="../../assets/chain/LinkedIn.png" /></a>
 </div>

 <div class="idioma  d-none d-lg-inline-block">
 	<p (click)="idioma('ESP')">ESP</p>
 	<p> | </p>
 	<p (click)="idioma('ENG')">ENG</p>
 </div>

 <img src="../../assets/chain/Group 17.png" class="menuMobile d-lg-none"  [matMenuTriggerFor]="appMenu" />
  <mat-menu id="mat-menu" #appMenu="matMenu" class="d-lg-none " >
        <span class="lg-none"> x</span>
        <div style="height: 70px;"></div>
         <button mat-menu-item (click) = "menclick('pat')" >
        	 {{menu1}}  
         </button> 
         <button mat-menu-item (click) = "menclick('somos')">
        	  {{menu2}}   
         </button> 
          <button mat-menu-item (click) = "menclick('serv')">
        	 {{menu3}}       
          </button> 
           <button mat-menu-item (click) = "menclick('proyy')" >
        	 {{menu5}}  
         </button> 
          
         <button mat-menu-item (click) = "menclick('con')" >
        	 {{menu4}}  
         </button> 
          <div class="redes redMob" >
		 	<a href="https://www.instagram.com/patagoniachain/?hl=es" target="_blank"><img src="../../assets/chain/Instagram.png" /> </a>
		 	
		 	<a href="https://www.linkedin.com/company/patagonia-chain/about/" target="_blank"> <img style="margin-left: 10px" src="../../assets/chain/LinkedIn.png" /> </a>
		 </div>

		 <div class="lineaRedes">
		 </div>

		

		  <div class="idioma  idMob">
			 	<p (click)="idioma('ESP')">ESP</p>
			 			<p>|</p>
			 	<p (click)="idioma('ENG')">ENG</p>
		 </div>




   </mat-menu>
-->

<app-header></app-header>
<router-outlet (activate)="onActivate($event)" > </router-outlet>
   <!--            

<div class="footer" id = "footer" >
	<img class="ilu" src="../../assets/chain/iluminacion fondo marino.png" />
	<div>
		<img class="logoFot" src = "../../assets/chain/Asset 181.png" />
		<h3 class="contactt">
			CON <br>
			TAC <br>
			TANOS.
		</h3>
	</div>
	<div class="contactoo">
	<div class="bloque1_c">
	  	<input name = "nombre" type="text" class = "precio" id="nombre" [(ngModel)]="nombre" [placeholder]=[nom]>
	    <input name = "email" type="text" class = "precio" id="email" [(ngModel)]="email" [placeholder]=[em]>
	</div>
    <div class="bloque2_c">
    	<textarea name = "mensaje" type="text" class = "precio" id="mensaje" [(ngModel)]="mensaje" [placeholder]=[msj]> </textarea>
    	<input name = "telefono" type="text" class = "precio" id="telefono" [(ngModel)]="telefono" [placeholder]=[tel]>
    	<div class="enviar" (click) = "enviar()"> {{env}} <img src="../../assets/chain/enviar.png" />  </div>
	</div>
	</div>
	<div class="d-lg-none" style="height: 100px;"> </div>
	<div> 
		<div class="bloq1"> 
			<p class="tit">{{explora}} </p>
			<p class="home" (click)="menclick('pat')"><br>{{homee}} </p>
			<p class="home" (click) = "menclick('somos')">{{about}}</p>
			<p class="home" (click) = "menclick('serv')">{{what}}</p>
		</div>
		<div class="bloq2"> 
			<p class="tit">{{social}} </p>
			<p class="home"><br>Linkedin </p>
			<p class="home">Instagram</p>
		</div>
		<div class="bloq3"> 
			<p class="tit">{{contactof}} </p>
			<p class="home"><br>juan.c@patagonia-chain.com </p>
			<p class="home">+54 03416-902287 </p>
		</div>
	

	</div>
    <img class="ballena" data-aos="fade-left" data-aos-duration ="1500" src="../../assets/chain/Asset 3.png" />
    <img class="arbust"  src="../../assets/chain/Asset 5.png" />
    <img class="bub1" id="bub1" src ="../../assets/chain/bubble1.png">
	<img class="bub2" id="bub2" src ="../../assets/chain/bubble2.png">
	<img class="bub3" id="bub3" src ="../../assets/chain/bubble3.png">

</div>



<p id ="envioo" *ngIf="corr == 1"> Se envió correctamente el mensaje ! </p>
<p id = "error" *ngIf="err == 1"> ¡Hubo un error! vuelve a intentar en unos segundos</p> 
-->